module.exports = __webpack_public_path__ + "assets/images/0cd6904f5bdbe3dae6a1315ebe83ce3f.png";